// import permissions from '../store/modules/permissions';

const Menu = [
  { header: 'apps' },
  {
    title: 'dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'dashboard'
    // admin: true
  },
  {
    title: 'chronometer',
    group: 'apps',
    icon: 'av_timer',
    name: 'chronometer'
  },
  {
    title: 'simpleChronometer',
    group: 'apps',
    icon: 'av_timer',
    name: 'simpleChronometer'
  },
  {
    title: 'match',
    group: 'apps',
    icon: 'forum',
    name: 'matches',
    requireRole: true
  },
  {
    title: 'tournament',
    group: 'apps',
    icon: 'poll',
    name: 'tournaments',
    requireRole: true
  },
  // {
  //   title: 'Notificaciones',
  //   group: 'apps',
  //   name: 'Notifications',
  //   icon: 'notifications',
  // },
  { header: 'management' },
  {
    title: 'entity',
    group: 'management',
    name: 'entities',
    icon: 'location_city',
    admin: true
  },
  {
    title: 'team',
    group: 'management',
    name: 'teams',
    icon: 'group',
    requireRole: true
  },
  {
    title: 'stadium',
    group: 'management',
    name: 'centers',
    icon: 'location_city',
    requireRole: true
    // admin: true
  },
  /* {
      title: 'pitch',
      group: 'management',
      name: 'pitches',
      icon: 'location_city'
    }, */
  {
    title: 'user',
    group: 'management',
    icon: 'person',
    name: 'users',
    requireRole: true
  },
  {
    title: 'act',
    group: 'management',
    name: 'acts',
    icon: 'assignment',
    requireRole: true
  },
  {
    title: 'aspect',
    group: 'management',
    name: 'aspects',
    icon: 'assignment',
    requireRole: true
  },
  {
    title: 'course',
    group: 'management',
    name: 'courses',
    icon: 'view_compact'
  },
  {
    title: 'advertising',
    group: 'management',
    name: 'advertisings',
    icon: 'chrome_reader_mode',
    admin: true
  },
  { divider: true, admin: true },
  { header: 'config', admin: true },
  {
    title: 'country',
    group: 'config',
    name: 'countries',
    icon: 'location_on',
    admin: true
  },
  {
    title: 'province',
    group: 'config',
    name: 'provinces',
    icon: 'location_on',
    admin: true
  },
  {
    title: 'town',
    group: 'config',
    name: 'cities',
    icon: 'location_on',
    admin: true
  },
  {
    title: 'category',
    group: 'managment',
    name: 'categories',
    icon: 'library_books',
    admin: true
  },
  {
    title: 'role',
    group: 'managment',
    name: 'roles',
    icon: 'recent_actors',
    admin: true
  },
  {
    title: 'language',
    group: 'managment',
    name: 'languages',
    icon: 'language',
    admin: true
  },
  { header: '' }
]
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase()
      let textB = y.title.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  }
})

export default Menu
